import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { addRole } from '../../../../redux/actions/roles&permissions/roles';
import { showToast } from '../../../../redux/actions/toasts';
import Add from './Add';

const mapDispatchToProps = (dispatch) => ({
  addRole: (data) => dispatch(addRole(data)),
  showToast: (message) => dispatch(showToast({ message })),
});

export default withRouter(connect(null, mapDispatchToProps)(Add));
